import {gsap} from "../../../libs/gsap/all.js";
import * as PIXI from "pixi.js";
import 'pixi.js/math-extras';
import {HarponTile} from "./HarponTile";

// Constructor
export class DisabledHarponTile extends HarponTile {

  constructor(rowIndex, colIndex) {
    super(rowIndex, colIndex);

    this.isValidMove = false;
    this.isDisabled = true;
    this.type = "disabled";

    this.build();
  }

  build() {
    super.build();
    //
    // // The background is used to set a dimension for the container but will remain invisible
    // this.background = new PIXI.Graphics().rect(0, 0, this.dimension.width, this.dimension.height).fill(0x00FF00);
    // this.background.alpha = 0.00;
    // this.addChild(this.background);

    // this.testedTile = new PIXI.Sprite(app.game.assets["tile-solid"]);
    // this.addChild(this.testedTile);
  }

  test() {
    app.audio.play(app.data.global.sounds.blocked_tile, 1.0, true);
  }

  // Reset the states so we can animate in again and start over
  reset() {
  }


}
